import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";

export const getStudentStats = async (enrollmentId) => {
  const res = await axios.apiCadernoVirtual("/diary-service/diary/dashinfo", {
    params: { enrollmentId },
  });
  return res.object[0];
};

export const useStudentStats = ({ config, enrollmentId } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["studentStats", { enrollmentId }],
    queryFn: () => getStudentStats(enrollmentId),
  });
};
